var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBridgeGround2 = function SvgBridgeGround2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1544,
    height: 254,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#719243",
    d: "M522.5 93.275c8.667-18.5 28.207-48.305 47-54 16.5-5 25.5 10 25.5 10 8.5-14 25.925-18.445 40-10 9.29 5.574 3.908 17.19-1.714 20.816 7.573-3.85 21.439-7.885 25.214 2.684 3.451 9.662-2.277 17.29-6.911 21.021 6.5-4.29 18.483-9.664 27.411-5.02 10 5.2 8.5 11.832 6.5 14.5 13.667-8.334 42.5-17 48.5 14.999H522.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M522.5 93.275c8.667-18.5 28.207-48.305 47-54 16.5-5 25.5 10 25.5 10 8.5-14 25.925-18.445 40-10 10 6 3 19-3 21.5 7.167-4 22.5-9.2 26.5 2s-4.333 19.667-9 22.5c5.667-4.333 19.5-11.7 29.5-6.5s8.5 11.833 6.5 14.5c13.667-8.333 42.5-17 48.5 15H522.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bridge-ground-2_svg__a)",
    stroke: "#000",
    d: "M511.5 107.5h521v298h-521z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#95BDFF",
    d: "M507 133h543v43H507z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#95BDFF",
    d: "M584.853 133.975c-36.413 0-53.207-6.421-61.853-17.22V108h211c-5.986 18.678-34.751 13.62-48.385 8.755 1.995 1.557 3.491 5.429-6.485 8.464s-23.777-1.265-29.43-3.794c-13.967 10.74-49.051 12.841-64.847 12.55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7CC55",
    stroke: "#000",
    d: "M0 97.5h-.5v298h552.479l.021-.479c4.001-93.539-3.877-167.825-12.757-218.732-4.441-25.453-9.132-45.062-12.713-58.31-1.791-6.624-3.305-11.658-4.372-15.038a200 200 0 0 0-1.243-3.82q-.217-.641-.33-.964l-.085-.243-.022-.062-.005-.015-.002-.004c0-.001 0-.002-.471.167l.471-.169-.119-.331H0ZM1551.12 97.5h.5v298h-544.1l-.02-.479c-4-93.531 1.78-167.811 8.56-218.712 3.39-25.451 7.04-45.057 9.83-58.303 1.4-6.623 2.58-11.656 3.42-15.034.42-1.69.75-2.965.98-3.82.11-.426.2-.748.26-.963q.045-.16.06-.243l.02-.061v-.016l.01-.004.48.135-.48-.136.1-.364h520.38Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 79,
    x: -21.5,
    y: 20.5,
    fill: "#B6DF5D",
    stroke: "#000",
    rx: 8.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 79,
    x: 0.5,
    y: -0.5,
    fill: "#B6DF5D",
    stroke: "#000",
    rx: 8.5,
    transform: "matrix(-1 0 0 1 1573.12 21)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#16643C",
    d: "M1055.69 10.934 1042.97 21.8c-.79.672-.16 1.95.86 1.739l4.74-.993a.38.38 0 0 1 .39.59c-.2.275.04.649.37.592l4.97-.845c.18-.031.29.203.14.322-.15.126-.02.372.17.317l2.7-.77c.27-.078.56.064.66.328.09.217.3.357.53.35 2.19-.075 13.01-.46 13.43-.803.85-.696 4.45-3.3 7.25-5.66.79-.672.15-1.62-.81-1.22l-7.76 3.232c-.81.337-1.63-.454-1.32-1.273l1.56-4.157c.27-.723-.35-1.45-1.09-1.262-3.59.902-8.53 2.804-11.79 4.163a1.013 1.013 0 0 1-1.38-1.145l.73-3.4c.2-.935-.9-1.592-1.63-.97"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1040 24.34 15.69-13.406c.73-.621 1.83.036 1.63.97l-.73 3.401c-.17.797.63 1.459 1.38 1.145 3.26-1.36 8.2-3.261 11.79-4.163.74-.188 1.36.54 1.09 1.262l-1.56 4.157c-.31.82.51 1.61 1.32 1.273l7.76-3.232c.96-.4 1.6.548.81 1.22-2.8 2.36-6.4 4.964-7.25 5.66"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m610.356 2-12.528 4.85 12.528 5.658 11.316-5.658z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m621 22-10.645 4.041V12.508l11.316-5.658z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#7A4A12",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m598.5 22.5 11.856 3.042V12.507L597.828 6.85z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m950.356 1-12.528 4.85 12.528 5.658 11.316-5.658z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m961 21-10.645 4.041V11.508l11.316-5.658z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#7A4A12",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m938.5 21.5 11.856 3.042V11.507L937.828 5.85z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M612.5 22.413H610l8 62.467 3 .302 7.5-.302H655l-10.5-64.607-16 2.14H625l-4.5-2.14h-8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M620.5 20.273h-8v2.14H610l8 62.467 3 .302 7.5-.302m-8-64.607 4.5 2.14h3.5l16-2.14L655 84.88h-26.5m-8-64.607c1.5 3.804 2 4.91 2 10.045 0 5.136 5.833 35.367 7 39.41m-1 15.152s-3.1-14.083-3.5-19.79m16-39.408c1.667 12.725 7 47.529 7 52.367"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M511 17.182h11l.5-.773h5.5l.5-.773h10l3 2.318 2.5 61.818h-12l-1.5-3.09v3.09H515l1.5-8.5-4.5 10.046h-10c2.5-12.364 7.5-38.636 7.5-44.818s1-15.455 1.5-19.318"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M538 79.773h6l-2.5-61.819-3-2.318H537m1 64.137h-6l-1.5-3.091v3.09H515l1.5-8.5-4.5 10.046h-10c2.5-12.364 7.5-38.636 7.5-44.818s1-15.455 1.5-19.318h11l.5-.773h5.5l.5-.773h8.5m1 64.137c-.833-11.334-2.4-36.782-2-47.91s.833-15.454 1-16.227"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    d: "M522 90.59h-18l-2-9.272h10l4.5-10.045-1.5 8.5h15.5v-3.091l1.5 3.09h12l.5 9.273H529l-1 .773h-5.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M518.5 79.773h12v-3.091l1.5 3.09h12l.5 9.273H529l-1 .773h-5.5l-.5.773h-18l-2-9.273h7m9.5-1.545H515l1.5-8.5-4.5 10.045h-3m9.5-1.545c1.167-9.273 3.8-29.982 5-38.637M509 81.318l13.5-56.41v-8.5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    d: "M544.5 92.909V80.545l38 3.864v8.5h-24l-2.5 1.545zM582.5 92.136V79.773l36.5 4.636v9.273h-8.5L598 95.227l-4-1.545zM619 93.836v-8.654h36v8.654h-21.205L632.315 96z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M544.5 20.273H542l2.5 60.272 2.5 5.41 7.5-.327 28-1.22-8.5-64.136h-17l-4.5-2.318h-8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M552.5 17.954h-8v2.319H542l2.5 60.272 2.5 5.41 7.5-.327m-2-67.674 4.5 2.319h17l8.5 64.136-28 1.219m-2-67.674c1.5 4.122 4.5 13.755 4.5 19.319s2.333 15.712 3.5 20.09m-6 28.265c-1.333-15.861-4.1-49.128-4.5-55.31m19 0c1.667 13.786 5 42.668 5 47.91"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M576.5 17.182H574l8.5 62.59 2.5 5.41 7.5-.327H619l-10.5-69.991-16 2.318H589l-4.5-2.318h-8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M584.5 14.864h-8v2.318H574l8.5 62.59 2.5 5.41 7.5-.327m-8-69.991 4.5 2.318h3.5l16-2.318L619 84.855h-26.5m-8-69.991c1.5 4.12 4.5 13.754 4.5 19.318 0 5.563 8.333 18.03 9.5 22.409m-6 28.264c-1.333-15.86-10.1-51.446-10.5-57.628m19 0c1.667 13.786 11 44.986 11 50.227"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M743.5 22.413H741l8 62.467 3 .302 7.5-.302H786l-10.5-64.607-16 2.14H756l-4.5-2.14h-8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M751.5 20.273h-8v2.14H741l8 62.467 3 .302 7.5-.302m-8-64.607 4.5 2.14h3.5l16-2.14L786 84.88h-26.5m-8-64.607c1.5 3.804 2 4.91 2 10.045 0 5.136 5.833 35.367 7 39.41m-1 15.152s-3.1-14.083-3.5-19.79m16-39.408c1.667 12.725 7 47.529 7 52.367"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M642 17.182h11l.5-.773h5.5l.5-.773h10l3 2.318 2.5 61.818h-12l-1.5-3.09v3.09H646l1.5-8.5-4.5 10.046h-10c2.5-12.364 7.5-38.636 7.5-44.818s1-15.455 1.5-19.318"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M669 79.773h6l-2.5-61.819-3-2.318H668m1 64.137h-6l-1.5-3.091v3.09H646l1.5-8.5-4.5 10.046h-10c2.5-12.364 7.5-38.636 7.5-44.818s1-15.455 1.5-19.318h11l.5-.773h5.5l.5-.773h8.5m1 64.137c-.833-11.334-2.4-36.782-2-47.91s.833-15.454 1-16.227"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    d: "M653 90.59h-18l-2-9.272h10l4.5-10.045-1.5 8.5h15.5v-3.091l1.5 3.09h12l.5 9.273H660l-1 .773h-5.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M649.5 79.773h12v-3.091l1.5 3.09h12l.5 9.273H660l-1 .773h-5.5l-.5.773h-18l-2-9.273h7m9.5-1.545H646l1.5-8.5-4.5 10.045h-3m9.5-1.545c1.167-9.273 3.8-29.982 5-38.637M640 81.318l13.5-56.41v-8.5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    d: "M675.5 92.909V80.545l38 3.864v8.5h-24l-2.5 1.545zM713.5 92.136V79.773l36.5 4.636v9.273h-8.5L729 95.227l-4-1.545zM750 93.836v-8.654h36v8.654h-21.205L763.315 96z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M675.5 20.273H673l2.5 60.272 2.5 5.41 7.5-.327 28-1.22-8.5-64.136h-17l-4.5-2.318h-8z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M683.5 17.954h-8v2.319H673l2.5 60.272 2.5 5.41 7.5-.327m-2-67.674 4.5 2.319h17l8.5 64.136-28 1.219m-2-67.674c1.5 4.122 4.5 13.755 4.5 19.319s2.333 15.712 3.5 20.09m-6 28.265c-1.333-15.861-4.1-49.128-4.5-55.31m19 0c1.667 13.786 5 42.668 5 47.91"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M707.5 17.182H705l8.5 62.59 2.5 5.41 7.5-.327H750l-10.5-69.991-16 2.318H720l-4.5-2.318h-8z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M715.5 14.864h-8v2.318H705l8.5 62.59 2.5 5.41 7.5-.327m-8-69.991 4.5 2.318h3.5l16-2.318L750 84.855h-26.5m-8-69.991c1.5 4.12 4.5 13.754 4.5 19.318 0 5.563 8.333 18.03 9.5 22.409m-6 28.264c-1.333-15.86-10.1-51.446-10.5-57.628m19 0c1.667 13.786 11 44.986 11 50.227"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M872.5 22.413H870l8 62.467 3 .302 7.5-.302H915l-10.5-64.607-16 2.14H885l-4.5-2.14h-8z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M880.5 20.273h-8v2.14H870l8 62.467 3 .302 7.5-.302m-8-64.607 4.5 2.14h3.5l16-2.14L915 84.88h-26.5m-8-64.607c1.5 3.804 2 4.91 2 10.045 0 5.136 5.833 35.367 7 39.41m-1 15.152s-3.1-14.083-3.5-19.79m16-39.408c1.667 12.725 7 47.529 7 52.367"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M771 17.182h11l.5-.773h5.5l.5-.773h10l3 2.318 2.5 61.818h-12l-1.5-3.09v3.09H775l1.5-8.5-4.5 10.046h-10c2.5-12.364 7.5-38.636 7.5-44.818s1-15.455 1.5-19.318"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M798 79.773h6l-2.5-61.819-3-2.318H797m1 64.137h-6l-1.5-3.091v3.09H775l1.5-8.5-4.5 10.046h-10c2.5-12.364 7.5-38.636 7.5-44.818s1-15.455 1.5-19.318h11l.5-.773h5.5l.5-.773h8.5m1 64.137c-.833-11.334-2.4-36.782-2-47.91s.833-15.454 1-16.227"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    d: "M782 90.59h-18l-2-9.272h10l4.5-10.045-1.5 8.5h15.5v-3.091l1.5 3.09h12l.5 9.273H789l-1 .773h-5.5z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M778.5 79.773h12v-3.091l1.5 3.09h12l.5 9.273H789l-1 .773h-5.5l-.5.773h-18l-2-9.273h7m9.5-1.545H775l1.5-8.5-4.5 10.045h-3m9.5-1.545c1.167-9.273 3.8-29.982 5-38.637M769 81.318l13.5-56.41v-8.5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    d: "M804.5 92.909V80.545l38 3.864v8.5h-24l-2.5 1.545zM842.5 92.136V79.773l36.5 4.636v9.273h-8.5L858 95.227l-4-1.545zM879 93.836v-8.654h36v8.654h-21.205L892.315 96z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M804.5 20.273H802l2.5 60.272 2.5 5.41 7.5-.327 28-1.22-8.5-64.136h-17l-4.5-2.318h-8z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M812.5 17.954h-8v2.319H802l2.5 60.272 2.5 5.41 7.5-.327m-2-67.674 4.5 2.319h17l8.5 64.136-28 1.219m-2-67.674c1.5 4.122 4.5 13.755 4.5 19.319s2.333 15.712 3.5 20.09m-6 28.265c-1.333-15.861-4.1-49.128-4.5-55.31m19 0c1.667 13.786 5 42.668 5 47.91"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M836.5 17.182H834l8.5 62.59 2.5 5.41 7.5-.327H879l-10.5-69.991-16 2.318H849l-4.5-2.318h-8z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M844.5 14.864h-8v2.318H834l8.5 62.59 2.5 5.41 7.5-.327m-8-69.991 4.5 2.318h3.5l16-2.318L879 84.855h-26.5m-8-69.991c1.5 4.12 4.5 13.754 4.5 19.318 0 5.563 8.333 18.03 9.5 22.409m-6 28.264c-1.333-15.86-10.1-51.446-10.5-57.628m19 0c1.667 13.786 11 44.986 11 50.227"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M1002.5 18.549h-2.5l8 62.468 3 .301 7.5-.301h26.5l-10.5-64.608-16 2.14h-3.5l-4.5-2.14h-8z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M1010.5 16.41h-8v2.139h-2.5l8 62.468 3 .301 7.5-.301m-8-64.608 4.5 2.14h3.5l16-2.14 10.5 64.608h-26.5m-8-64.608c1.5 3.804 2 4.91 2 10.046s5.83 35.367 7 39.409m-1 15.153s-3.1-14.083-3.5-19.79m16-39.409c1.67 12.726 7 47.529 7 52.367"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M901 13.318h11l.5-.772h5.5l.5-.773h10l3 2.318 2.5 61.818h-12l-1.5-3.09v3.09H905l1.5-8.5-4.5 10.046h-10c2.5-12.364 7.5-38.637 7.5-44.818 0-6.182 1-15.455 1.5-19.319"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M928 75.91h6l-2.5-61.819-3-2.318H927m1 64.136h-6l-1.5-3.09v3.09H905l1.5-8.5-4.5 10.046h-10c2.5-12.364 7.5-38.637 7.5-44.818 0-6.182 1-15.455 1.5-19.319h11l.5-.772h5.5l.5-.773h8.5m1 64.136c-.833-11.333-2.4-36.782-2-47.909s.833-15.454 1-16.227"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    d: "M912 86.727h-18l-2-9.273h10l4.5-10.045-1.5 8.5h15.5v-3.09l1.5 3.09h12l.5 9.273H919l-1 .772h-5.5z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M908.5 75.909h12v-3.09l1.5 3.09h12l.5 9.273H919l-1 .772h-5.5l-.5.773h-18l-2-9.273h7m9.5-1.545H905l1.5-8.5-4.5 10.045h-3m9.5-1.545c1.167-9.273 3.8-29.982 5-38.636M899 77.454l13.5-56.409v-8.5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    d: "M934.5 89.046V76.682l38 3.864v8.5h-24L946 90.59zM972.5 88.273V75.909l36.5 4.636v9.273h-8.5L988 91.364l-4-1.546zM1009 89.973v-8.655h36v8.655h-21.21l-1.47 2.163z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M934.5 16.409H932l2.5 60.273 2.5 5.409 7.5-.327 28-1.219L964 16.41h-17l-4.5-2.318h-8z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M942.5 14.09h-8v2.319H932l2.5 60.273 2.5 5.409 7.5-.327m-2-67.673 4.5 2.318h17l8.5 64.136-28 1.22m-2-67.674c1.5 4.121 4.5 13.754 4.5 19.318s2.333 15.712 3.5 20.09m-6 28.265c-1.333-15.86-4.1-49.128-4.5-55.31m19 0c1.667 13.786 5 42.668 5 47.91"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    d: "M966.5 13.318H964l8.5 62.591 2.5 5.41 7.5-.327h26.5L998.5 11l-16 2.318H979L974.5 11h-8z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M974.5 11h-8v2.318H964l8.5 62.591 2.5 5.41 7.5-.327M974.5 11l4.5 2.318h3.5l16-2.318 10.5 69.992h-26.5M974.5 11c1.5 4.121 4.5 13.755 4.5 19.318s8.333 18.03 9.5 22.41m-6 28.264c-1.333-15.861-10.1-51.446-10.5-57.628m19 0c1.667 13.785 11 44.985 11 50.227"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#16643C",
    d: "M484.491 16.532c2.019 1.052 7.131 5.021 9.784 7.153a1 1 0 0 0 .88.188l2.158-.563a.428.428 0 0 1 .451.671.429.429 0 0 0 .461.67l4.604-1.316c.313-.09.54.296.31.526-.245.245.026.649.345.514l2.559-1.077c.419-.176.777.35.46.675-.292.298-.012.792.394.695l2.043-.485c.451-.107.764-.52.939-.949.708-1.733 3.5-4.033 6.073-5.832.833-.582.444-1.712-.54-1.46-2.32.596-4.634 1.598-6.244 2.416-.611.31-1.255-.058-1.015-.7.542-1.452 1.918-3.382 3.177-4.937.547-.675.076-1.611-.756-1.36-3.538 1.07-7.35 4.29-9.616 6.607-.488.499-1.31.367-1.343-.33a5 5 0 0 1 .114-1.273c.211-1.006-.907-2.191-1.774-1.64-1.973 1.258-3.273 2.509-4.009 3.417-.365.45-1.026.623-1.551.378-3.337-1.558-10.298-3.235-7.904-1.988"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M494.667 24c-2.507-2.028-8.052-6.362-10.176-7.468-2.394-1.247 4.567.43 7.904 1.988.525.245 1.186.072 1.551-.378.736-.908 2.036-2.16 4.009-3.416.867-.552 1.985.633 1.774 1.639a5 5 0 0 0-.114 1.273c.033.697.855.829 1.343.33 2.266-2.317 6.078-5.537 9.616-6.607.832-.251 1.303.685.756 1.36-1.259 1.555-2.635 3.485-3.177 4.937-.24.642.404 1.01 1.015.7 1.61-.818 3.924-1.82 6.244-2.416.984-.252 1.373.878.54 1.46-2.975 2.08-6.243 4.83-6.243 6.598"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M959.865 66 946 71.367l13.865 6.261 12.522-6.261z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m967.466 168.028-7.603 4.472V77.628l12.523-6.261z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#7A4A12",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m950.367 170.133 9.498 2.367V77.628L946 71.367z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    d: "M988.598 91 960 113.475V124.5l41-33.5z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M917.538 89 948 113.049V123l-44-34z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#87662A",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m917 89 31 24v-3.31L921.306 89z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#BC9549",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M600.865 67 590 73l10.865 5.628 12.522-6.261z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m608.466 169.028-7.603 4.472V78.628l12.523-6.261z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#7A4A12",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m591.367 171.133 9.498 2.367V78.628L590 73z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#76500D",
    stroke: "#000",
    d: "m572 93 18.5 18v12l-31-30z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#87662A",
    stroke: "#000",
    d: "m572.5 93.5 18 17.5v-4l-13-13.5z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#14653C",
    stroke: "#000",
    d: "M1064.69 85.462c-1.37 3.18-4.22 5.337-5.47 6.018.77-2.306 2.88-7.747 5.19-11.066 2.89-4.149 7.79-4.963 8-3.143s-6 4.216-7.72 8.191ZM1050.65 82.989c4.29 1.125 7.14 3.656 8.03 4.78-.18-3.193-3.79-6.086-6.73-6.668s-6.66.48-1.3 1.888Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#14653C",
    stroke: "#000",
    d: "M1058.56 89.625c-.43-7.73-2.47-12.14-3.44-13.378.05-1.582.67-3.7 2.72.494 2.56 5.241 1.27 22.546.72 12.883Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#F08A95",
    stroke: "#000",
    d: "M1053.48 59.16c8.45-3.767 9.91-1.836 12.59 0 5.25 5.309 2.68 9.662-2.68 11.692s-3.57 7.956-8.45 9.5c-3.89 1.233-6.76-1.165-7.71-2.518-3.38.65-10.16.163-10.23-6.982-.08-8.931 5.93-6.983 16.48-11.692Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#E36974",
    d: "M1058.29 59.787c2.99-2.338 5.74.325 6.74 1.949.98 2.841 1.14 5.44-4.54 8.119-5.69 2.679-4.55 5.44-11.78 6.738-7.22 1.3-10.31-9.418-6.25-11.772s5.93 3.166 9.58 2.354c3.66-.812 2.52-4.465 6.25-7.388"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF479",
    d: "M1049.15 65.662c-2.59 2.355-.4 3.654 2.6 2.76 1.39-.413 2.56-1.302 3.41-2.166-1.3-2.167-3.41-2.948-6.01-.594"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M1056.46 64.607c-.24.41-.68 1.022-1.3 1.649m0 0c-.85.864-2.02 1.752-3.41 2.167-3 .893-5.19-.406-2.6-2.76 2.6-2.355 4.71-1.574 6.01.593Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M586 155.165c-11.162 2.269-19 7.609-19 13.835 0 8.284 13.879 15 31 15s31-6.716 31-15c0-5.552-6.234-10.4-15.5-12.993"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M598 188c22.091 0 40-8.617 40-19.248 0-7.124-8.044-13.344-20-16.672m-60 16.672c0-7.988 10.114-14.84 24.516-17.752M944 155.165c-11.162 2.269-19 7.609-19 13.835 0 8.284 13.879 15 31 15s31-6.716 31-15c0-5.552-6.234-10.4-15.5-12.993"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M996 168.753c0-7.125-8.044-13.345-20-16.673M956 188c-22.091 0-40-8.617-40-19.247"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bridge-ground-2_svg__a",
    x1: 772,
    x2: 772,
    y1: 108,
    y2: 405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#609BFF"
  })))));
};
export default SvgBridgeGround2;